import { createContext } from 'react';

export const OnLogoutContext = createContext(() => {
});